import { Box } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import MDEditor from '@uiw/react-md-editor';
import { useMutation } from 'react-query';
import { userActivity } from '../../../../apis/V2/userActivity';
import { AxiosError } from 'axios';
import { UIErrorResponse } from 'types/src/error';

let scrollTimeout: NodeJS.Timeout;

const ResourceMarkdown = ({ resource }: any) => {
	const [scrollProgress, setSrcollProgress] = useState(0);
	const [scrollProgressData, setSrcollProgressData] = useState({ completionPercentage: 0 });
	const markdownContent = resource?.content?.description;

	const { mutate: updateUserActivity, isLoading: isUserActivityLoading } = useMutation(userActivity, {
		onSuccess: e => {
			if (scrollProgressData?.completionPercentage < e.data?.userProgress?.completionPercentage) {
				setSrcollProgressData(e.data?.userProgress);
			}
		},
		onError: (error: AxiosError<UIErrorResponse>) => {
			console.log('error:', error);
		},
	});

	useEffect(() => {
		if (!resource) {
			return;
		}
		// Clear the previous timeout if exists
		clearTimeout(scrollTimeout);

		// Set a new timeout to call updateUserActivity after a delay
		scrollTimeout = setTimeout(() => {
			if (scrollProgressData?.completionPercentage < scrollProgress) {
				updateUserActivity({
					entityType: 'Resource',
					entity: resource?._id,
					completionPercentage: scrollProgress,
				});
			}
		}, 1000); // Adjust the delay as needed
	}, [scrollProgress, scrollProgressData, resource]);

	useEffect(() => {
		if (!resource?._id) {
			return;
		}
		updateUserActivity({
			entityType: 'Resource',
			entity: resource?._id,
			completionPercentage: 0,
		});

		const scrollElement = document.querySelector('#scrollDiv');
		if (!scrollElement) {
			return;
		}

		scrollElement.addEventListener('scroll', e => {
			const scrollProgress = Math.round((scrollElement.scrollTop / Math.round(scrollElement.scrollHeight - scrollElement.clientHeight)) * 100);
			setSrcollProgress(scrollProgress);
		});

		return () => {
			scrollElement.removeEventListener('scroll', e => {
				const scrollProgress = Math.round((scrollElement.scrollTop / Math.round(scrollElement.scrollHeight - scrollElement.clientHeight)) * 100);
				setSrcollProgress(scrollProgress);
			});
		};
	}, [resource?._id]);

	// Define light mode styles
	const lightModeStyles = {
		padding: '16px',
		borderRadius: '16px',
		background: 'white', // or another light color that suits your design
		color: 'black', // or another dark color that suits your design
		// Add any other styles to override dark mode settings
	};
	return (
		<Box data-color-mode="light">
			<MDEditor.Markdown
				// turn dark mode off
				style={lightModeStyles}
				source={markdownContent}
			/>
		</Box>
	);
};

export default ResourceMarkdown;
